import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const numberFormats = {
  'de': {currency: {style: 'currency', currency: 'EUR'}, percent: {style: 'percent'}},
  'en': {currency: {style: 'currency', currency: 'USD'}, percent: {style: 'percent'}},
  'es': {currency: {style: 'currency', currency: 'USD'}, percent: {style: 'percent'}},
  'fr': {currency: {style: 'currency', currency: 'EUR'}, percent: {style: 'percent'}},
  'pt': {currency: {style: 'currency', currency: 'EUR'}, percent: {style: 'percent'}},
}

export default new VueI18n({
  locale: localStorage.getItem('wallet_lang') ?? 'es',
  fallbackLocale: localStorage.getItem('wallet_lang') ?? 'es',
  messages: loadLocaleMessages(),
  numberFormats : numberFormats
})
